import React from "react";
import { Button, TextField, Box, Paper, InputAdornment } from "@mui/material";
import BarraTitulo from "../Generico/BarraTitulo";
import AuthService from "../../AuthService";
import Grid from "@mui/material/Grid";
import { useSnackbar } from "notistack";

export default function ConfigurarEndereco() {
  const service = new AuthService();
  const { enqueueSnackbar } = useSnackbar();
  const [identificadores, setIdentificadores] = React.useState([]);

  const handleChange = (event, identificador) => {
    let index = identificadores.findIndex((el) => el.id === identificador.id);
    identificadores[index].uuid = event.target.value;
  };

  const handleSubmit = (identificador) => {
    let string = `{ "id": ${identificador.id}, "uuid": "${identificador.uuid}" }`;
    let json = JSON.parse(string);
    service
      .put("/identificador/changeOnly", json)
      .then((resp) => {
        enqueueSnackbar("Sucesso ao salvar informações.", {
          variant: "success",
        });
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Erro ao salvar informações.", { variant: "error" });
        } else {
          enqueueSnackbar(
            "Já existe um endereço cadastrado com esse valor: " +
              identificador.uuid,
            { variant: "error" }
          );
        }
      });
  };

  React.useEffect(() => {
    service
      .get("/identificador/tipo/DELIVERY")
      .then((resp) => {
        setIdentificadores(resp);
      })
      .catch((err) => {
        console.error(err);
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <BarraTitulo title="configurar endereço do cardápio digital" />
      <Paper>
        <Box p={3}>
          <Grid container spacing={2} alignItems="center">
            {identificadores.map((identificador) => (
              <React.Fragment key={identificador.id}>
                <Grid
                  size={{
                    xs: 12,
                    sm: 10,
                  }}
                >
                  <TextField
                    variant="outlined"
                    label="Endereço digital"
                    name="uuid"
                    onChange={(e) => handleChange(e, identificador)}
                    defaultValue={identificador.uuid || ""}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          .qrpedir.com
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    sm: 2,
                  }}
                >
                  <Button
                    fullWidth
                    color="secondary"
                    sx={{ height: "3.5rem" }}
                    onClick={() => handleSubmit(identificador)}
                    variant="contained"
                  >
                    Salvar
                  </Button>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Box>
      </Paper>
    </React.Fragment>
  );
}
